import './contacto.css'

const InfoContacto = (props) => {
  return props.contacto.map((c) => (
    <div key={c.id}>
      <div className="col-4 mt-3">
        <ul>
          <li className="item-contacto">
            <i className="fa fa-phone f-blue f-size-20" aria-hidden="true"></i>
            Teléfono
          </li>
          <ul className="sub-lista">
            <li>{c.telefono}</li>
          </ul>
          <li className="item-contacto">
            <i className="fa fa-envelope-o f-blue f-size-20" aria-hidden="true"></i>
            E-mail Soporte
          </li>
          <ul className="sub-lista">
            <li>{c.emailSoporte}</li>
          </ul>
          <li className="item-contacto">
            <i className="fa fa-envelope-o f-blue f-size-20" aria-hidden="true"></i>
            E-mail cobranzas
          </li>
          <ul className="sub-lista">
            <li>{c.emailCobranzas}</li>
          </ul>
        </ul>
      </div>
    </div>
  ))
}

export default InfoContacto
